import { render, staticRenderFns } from "./ModalShipping.vue?vue&type=template&id=6d7796c8&"
import script from "./ModalShipping.vue?vue&type=script&lang=js&"
export * from "./ModalShipping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports